var render = function render(){var _vm=this,_c=_vm._self._c;return _c('install-app-wrap',[_c('app-sidebar-link',{attrs:{"link":_vm.INSTALL_APP_LINK,"hideTooltips":_vm.disabledTooltip}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }